import useAuthenticationFlows from "@/account/composables/use-authentication-flows";
import { ResponsiveUtils } from "@/shared/utils/responsive/responsive-utils";

const cardSwappedClass = "swapped";

document.ready(() => {
    const root = document.querySelector(".benefits");

    if (!root) return;

    const { openRegistrationModal } = useAuthenticationFlows();
    root.querySelector(".benefits__registration")?.addEventListener("click", openRegistrationModal);

    if (ResponsiveUtils.isOnlyTouchDevice()) {
        root.classList.add("disable-hover");

        const cards = root.querySelectorAll(".benefit-card");

        cards.forEach((cardOfEvent) =>
            cardOfEvent.addEventListener("click", () => {
                if (cardOfEvent.classList.contains(cardSwappedClass)) {
                    cardOfEvent.classList.remove(cardSwappedClass);
                } else {
                    cards.forEach((card) => card.classList.remove(cardSwappedClass));
                    cardOfEvent.classList.add(cardSwappedClass);
                }
            }),
        );
    }
});
